import { atom } from 'recoil';

export const mapDataAtom = atom({
    key: 'mapData',
    default: {
        name: '',
        current: 0,
        hexes: [{
            id: 0,
            label: '',
            description: '',
            order: 0,
            map: '',
            detail1: { label: '', description: '' },
            detail2: { label: '', description: '' },
            detail3: { label: '', description: '' },
            npcs: [{ name: '', title: '', stats: '', description: '' }],
            bestiary: [{ name: '', stats: '', description: '' }],
            items: [{ name: '', description: '' }],
        }],
    },
});

export const nextOpenAtom = atom({
    key: 'nextOpen',
    default: 1,
});

export const hexDetailIdAtom = atom({
    key: 'hexDetailId',
    default: 0,
});

export const hostPrefixAtom = atom({
    key: 'hostPrefix',
    default: window.location.hostname === 'marcmajcher.github.io' ? '/vipers-elegy' : ''
});

export const navIndex = atom({
    key: 'navIndex',
    default: 0,
});
